import { memo, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import PropTypes from 'prop-types'

import { useGetOrderQuery } from '@/app/services/orders'
import { selectOrganisationId } from '@/app/slices/organisationSlice'
import AppToolbar from '@/common/components/AppBar/AppToolbar'
import { ORDER_STATUS_ARRAY } from '@/common/utils'

import DownloadDocuments from '../DownloadDocuments/DownloadDocuments'

import AddPartsButtonGroup from './AddPartsButtonGroup'

const OrderToolbar = () => {
    const { orderId } = useParams()

    const organisationId = useSelector(selectOrganisationId)

    const { data: order, isFetching, isLoading } = useGetOrderQuery({ organisationId, orderId })

    const isAddPartsDisabled = useMemo(() => {
        return [
            ORDER_STATUS_ARRAY.Draft,
            ORDER_STATUS_ARRAY.Issued,
            ORDER_STATUS_ARRAY.Ordered,
            ORDER_STATUS_ARRAY.Invoiced,
            ORDER_STATUS_ARRAY.Cancelled,
            ORDER_STATUS_ARRAY.PendingOrderConfirmation,
            ORDER_STATUS_ARRAY.Rejected,
            ORDER_STATUS_ARRAY.Voided,
        ].includes(order?.status)
    }, [order?.status])

    return (
        <AppToolbar>
            {isAddPartsDisabled ? (
                <DownloadDocuments
                    data-testid="documents-button"
                    disabled={isLoading || isFetching}
                    order={order}
                    disableElevation
                />
            ) : null}

            {!isAddPartsDisabled ? <AddPartsButtonGroup /> : null}
        </AppToolbar>
    )
}

OrderToolbar.propTypes = {}

export default memo(OrderToolbar)
